import styled from '@emotion/styled'

/**
 * AddressSearchModal — Daum Postcode embed 를 fullscreen 오버레이로 wrapping.
 *
 * 헤더 정책:
 *  - 자체 헤더(X 버튼 등) 미렌더 — Daum iframe 자체 동작 제어 불가로 인한 가림 한계.
 *    검색 화면 닫기는 네이티브 헤더(←) / 인앱 뒤로가기에 의존.
 *  - 결과 화면은 SearchInputDisplay 의 ⓧ(검색으로 복귀) + 본문 내 보조 링크가 자체 처리.
 *  - 색상 매칭만 Daum theme prop 으로 (검색바 회색 톤, 폰트·아이콘은 라이브러리 한계).
 */

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`

/** Daum embed iframe 컨테이너 — Overlay 전체를 채움 */
export const EmbedWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  overflow: hidden;
`

/**
 * 결과 화면 컨테이너 — 검색 인풋(상단) + 본문(스피너/Available/Unavailable)을 묶음.
 * 본문은 flex 1로 남는 영역 채움, isLoading→스피너→결과로 본문만 swap.
 */
export const ResultWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  overflow-y: auto;
`
